// extracted by mini-css-extract-plugin
export var aboveInput = "_ml-0";
export var actionButton = "_ml-5";
export var actionButtonContainer = "_ml-1";
export var actionIcon = "_ml-6";
export var aiInfoContainer = "_ml-2";
export var attachmentWrapper = "_ml-7";
export var bold = "_ml-3";
export var checkIcon = "_ml-8";
export var clickingRecipientBar = "_ml-11";
export var commentThreadSwitch = "_ml-a";
export var draftImage = "_ml-b";
export var draftImageContainer = "_ml-c";
export var draftImages = "_ml-e";
export var editButton = "_ml-g";
export var editor = "_ml-f";
export var editorContainer = "_ml-y";
export var editorErrorTooltipWrapper = "_ml-9";
export var headerDivider = "_ml-h";
export var icon = "_ml-i";
export var info = "_ml-j";
export var internal = "_ml-n";
export var internalDivider = "_ml-k";
export var internalMessage = "_ml-l";
export var messageInputCard = "_ml-m";
export var messageInputForm = "_ml-o";
export var messageInputFormInternal = "_ml-p";
export var options = "_ml-q";
export var publicMessageCustomer = "_ml-s";
export var publicMessageMerchant = "_ml-r";
export var removeImageButton = "_ml-d";
export var replyButtons = "_ml-t";
export var showSignatureButton = "_ml-u";
export var spinner = "_ml-v";
export var verticalButtonDivider = "_ml-4";
export var visibilitySelector = "_ml-w";
export var warning = "_ml-x";
export var wrappingText = "_ml-z";
export var writingInternalNoteTopBorder = "_ml-10";